import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { get } from "../api/axios"
import endpoints from "../api/endpoints"
import { ADMIN_ME_WITH } from "../helpers/adminMe"
import { getUserAvatarUrl } from "../helpers/userAvatar"
import {
  setAdminMeLoaded,
  setUser,
  setUserPic,
} from "../store/slices/authSlice"

/**
 * Bootstrap admin session from GET /api/v1/user/me on AdminLayout mount.
 * Loads staff role permissions and profile media for the sidebar.
 */
const useAdminMe = () => {
  const dispatch = useDispatch()
  const jid = useSelector(state => state.auth.jid)

  useEffect(() => {
    if (!jid) return undefined

    let cancelled = false
    dispatch(setAdminMeLoaded(false))

    const loadMe = async () => {
      try {
        const response = await get(endpoints.getMe, {
          params: { "with[]": ADMIN_ME_WITH },
          skipErrorToast: true,
        })
        if (cancelled) return

        if (response?.data?.success) {
          const user = response.data.result || {}
          dispatch(setUser(user))

          const avatarUrl = getUserAvatarUrl(user)
          if (avatarUrl) dispatch(setUserPic(avatarUrl))
        }
      } catch {
        // Keep login payload when /me is unavailable.
      } finally {
        if (!cancelled) {
          dispatch(setAdminMeLoaded(true))
        }
      }
    }

    loadMe()
    return () => {
      cancelled = true
    }
  }, [dispatch, jid])
}

export default useAdminMe
